// extracted by mini-css-extract-plugin
export default {"inputs-list":"svfsK","inputs-row":"Bz02u","add-button":"DyTfh"};